import React from "react";

import classNames from "classnames/bind";

import FontAwesome from "react-fontawesome";

import styles from "./QuickFilter.module.scss";

import type { QuickFilterProps } from "./types";

const cx = classNames.bind(styles);

const QuickFilter = ({
  variant = "default",
  label,
  count,
  onClick,
  loading,
  active,
}: QuickFilterProps) => {
  return (
    <div
      className={cx(
        "quickFilter",
        variant,
        active ? "background" : "",
        onClick ? "clickable" : ""
      )}
      onClick={() => {
        if (onClick) {
          onClick();
        }
      }}
    >
      {label}{" "}
      {count || count === 0 ? (
        <span
          className={cx("count", ...(!active ? ["background", variant] : []))}
        >
          {loading ? (
            <FontAwesome
              name="spinner"
              spin
            />
          ) : (
            count
          )}
        </span>
      ) : null}
    </div>
  );
};

export default QuickFilter;
